import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";
import moment from "moment";
import { AppState } from "../../../../redux/reducers/rootReducer";
import { uiCloseModalSee } from "../../../../redux/actions/uiActions";
import { setActiveCorrespondence } from "../../../../redux/actions/correspondenceActions";
import { firebase } from "../../../../config/firebase/firebase-config";

function useReturned() {
  const intl = useIntl();
  const dispatch = useDispatch();

  const { modalSeeOpen } = useSelector((state: AppState) => state.ui);
  const { activeCorrespondence } = useSelector(
    (state: AppState) => state.documentManagment
  );
  const date =
    activeCorrespondence?.createAt &&
    moment(
      (activeCorrespondence.createAt as firebase.firestore.Timestamp).toDate()
    ).format("YYYY/MM/DD - h:mm:ss");

  const onDeny = () => {
    dispatch(uiCloseModalSee());
    dispatch(setActiveCorrespondence(null));
  };

  return { intl, modalSeeOpen, date, onDeny, activeCorrespondence };
}

export default useReturned;
